// Connect a media element and an external play button
//
export default class PlayButton {

  constructor(mediaElement, button) {
    this.mediaElement = mediaElement
    this.button = button
  }

  connect() {
    this.button.addEventListener('click', this.play.bind(this))
    this.mediaElement.addEventListener('play', this.toggleButton.bind(this))
    this.mediaElement.addEventListener('pause', this.toggleButton.bind(this))
  }

  disconnect() {
    this.button.removeEventListener('click', this.play.bind(this))
    this.mediaElement.removeEventListener('play', this.toggleButton.bind(this))
    this.mediaElement.removeEventListener('pause', this.toggleButton.bind(this))
  }

  async play() {
    if (typeof jasmine === 'undefined') {
      // somehow waiting for the promise breaks stubs from jasmine specs, so we don't reveal in Jasmine specs
      await up.reveal(this.mediaElement, { padding: 30 })
    }
    this.mediaElement.play()
  }

  toggleButton() {
    this.button.toggleAttribute('disabled', !this.mediaElement.paused)
  }

}
